import * as moment from 'moment';

export function dateIsoToLocal(date) {
    if(!date) return date
    return date.split('-').reverse().join('/')
}

export function dateTimeIsoToLocal(dateTime) {
    if(!dateTime) return dateTime
    dateTime = dateTime.toString() + 'Z'
    var d = new Date(dateTime);
    return d.toLocaleString("pt-BR")
}

export function dateLocalToIso(date) {
    if(!date) return date
    return date.split('/').reverse().join('-')
}

export function uepTypeExpand(type){
    if (type == "UP") return "UPL"
    if (type == "CR") return "Creche"
    if (type == "TR") return "Terminação"
    if (type == "WF") return "Wean to Finish"
    return "??"
}

export function formatCNPJ (nrDocumento) {
    if (nrDocumento != undefined)
    {
        nrDocumento = nrDocumento.replace( /\D/g , ""); //Remove tudo o que não é dígito
        nrDocumento = nrDocumento.replace( /^(\d{2})(\d)/ , "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
        nrDocumento = nrDocumento.replace( /^(\d{2})\.(\d{3})(\d)/ , "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
        nrDocumento = nrDocumento.replace( /\.(\d{3})(\d)/ , ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
        nrDocumento = nrDocumento.replace( /(\d{4})(\d)/ , "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
    }
    return nrDocumento;
}

export function formatCPF (nrDocumento) {
    if (nrDocumento != undefined)
    {
        nrDocumento = nrDocumento.replace( /\D/g , ""); //Remove tudo o que não é dígito
        nrDocumento = nrDocumento.replace( /(\d{3})(\d)/ , "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
        nrDocumento = nrDocumento.replace( /(\d{3})(\d)/ , "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
        nrDocumento = nrDocumento.replace( /(\d{3})(\d{1,2})$/ , "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
    }
    return nrDocumento;
}

export function daysBetweenDates (data1, format1, data2, format2) {
    var a = moment(data1, format1)
    var b = moment(data2, format2)
    return (a.diff(b, 'days'))

   //return  moment(data, "YYYY-MM-DD").fromNow()
}

